import { Component, OnInit } from '@angular/core';
import { GetCountriesService } from '../get-countries.service';
import * as _ from 'lodash';

export interface Exchanges {
  name: string;
  fee: string;
  exrate: string;
  limit: string;
  speed: string;
  url: string;
}

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  countryList: any[];
  dropDown = false;
  selectedCountry: any;
  responseData: any;
  input: string;

  constructor(private countries: GetCountriesService) {}

  ngOnInit(): void {
    this.countries
      .getCountries()
      .then((res) => {
        this.countryList = res;
      })
      .catch((err) => console.error(err));
  }

  hideDropDown(): void {
    this.dropDown = !this.dropDown;
  }

  select(country: any): void {
    this.selectedCountry = country;
    this.hideDropDown();
  }

  fetchData(form): void {
    console.log('Form: ', form);

    this.input = form.amount.toString();
    console.log(this.input);

    let body = new FormData();
    body.append('Origin', 'USA');
    body.append('Destination', this.selectedCountry.name);
    body.append('amount', form.amount);
    body.append('pay', form.pay);
    body.append('receipt', form.receipt);

    this.countries.getRates(body).then((res) => {
      console.log('Results:', res);

      var newArrayDataOfOjbect = Object.entries(res).map((e) => ({
        [e[0]]: e[1],
      }));
      console.log(newArrayDataOfOjbect);

      const keys = Object.keys(res);
      let newArray = [];

      keys.forEach((key) => {
        if (res[key].exrate !== 'NA' && res[key].origin !== 'NA') {
          let newPush: Exchanges;

          if (key === 'wave') {
            const local: Exchanges = {
              name: 'Wave',
              fee: res[key].exfee,
              exrate: res[key].exrate,
              limit: '999',
              speed: 'Minutes',
              url: 'https://www.sendwave.com/',
            };

            newPush = local;
          } else if (key === 'mg') {
            const local: Exchanges = {
              name: 'MoneyGram',
              fee: res[key].fee,
              exrate: res[key].exrate,
              limit: res[key].limit,
              speed: res[key].speed,
              url: 'https://www.moneygram.com/',
            };
            newPush = local;
          } else if (key === 'rml') {
            const local: Exchanges = {
              name: 'Remitly: Economy',
              fee: res[key].fee_economy,
              exrate: res[key].fx_economy,
              limit: '999',
              speed: '3-5 Days',
              url: 'https://www.remitly.com/',
            };

            const localExpress: Exchanges = {
              name: 'Remitly: Express',
              fee: res[key].fee_express,
              exrate: res[key].fx_express,
              limit: '999',
              speed: 'Minutes',
              url: 'https://www.remitly.com/',
            };
            newArray.push(localExpress);
            newPush = local;
          } else if (key === 'wremit') {
            const local: Exchanges = {
              name: 'WorldRemit',
              fee: res[key].fee,
              exrate: res[key].exrate,
              limit: res[key].limit,
              speed: res[key].speed,
              url: 'https://www.worldremit.com/',
            };
            newPush = local;
          } else if (key === 'wu') {
            const local: Exchanges = {
              name: 'WesternUnion',
              fee: res[key].fee,
              exrate: res[key].exrate,
              limit: res[key].limit,
              speed: res[key].speed,
              url: 'https://www.westernunion.com/',
            };
            newPush = local;
          } else if (key === 'xoom') {
            const local: Exchanges = {
              name: 'Xoom',
              fee: res[key].fee,
              exrate: res[key].exrate,
              limit: res[key].limit,
              speed: res[key].speed || 'Minutes',
              url: 'https://www.xoom.com/',
            };
            newPush = local;
          }
          newArray.push(newPush);
        }
      });

      newArray.sort((a, b) => {
        return (
          this.getAmountNum(b.exrate, this.input, b.fee) -
          this.getAmountNum(a.exrate, this.input, a.fee)
        );
      });
      this.responseData = newArray;
      console.log(newArray);
    });
  }

  getAmount(rate: string, value: string, fee: string): string {
    const currency = this.selectedCountry.currencies[0].code;

    return currency + ' ' + this.getAmountNum(rate, value, fee).toFixed(2);
  }

  getAmountNum(rate: string, value: string, fee: string): number {
    const numRate = Number(rate);
    const numVal = Number(value);
    const numFee = Number(fee);

    return numRate * (numVal - numFee);
  }
}
